import React, { useEffect, useState } from 'react'
import swal from 'sweetalert'
import RetirementIcon from '../../../assets/401k.png'
import CompanyLogo from '../../../assets/afbc.png'
import Side2 from '../../../assets/new_side_11.jpg'
import TrustIcon from '../../../assets/self-directed.svg'
import Button from '../../../components/Button'
import LoaderModal from '../../../components/Modals/LoaderModal'
import Stepper from '../../../components/Stepper'

import { IFormProps, RetirementAccountEnum } from '../../../interfaces'

import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import MessageModal from 'components/Modals/MessageModal'
import { RiseUpErrors } from 'constants/errors'
import useErrorMessage from 'hooks/useErrorMessage'
import { useGTMData } from 'hooks/useGTMData'
import { useUTMTracking } from 'hooks/useUTMTracking'
import queryString from 'query-string'
import { useLocation, useNavigate } from 'react-router-dom'
import { getModifiedUrlWithStep } from 'utils'
import { useRiseUpAPIV1 } from '../../../hooks/useRiseUpAPIV1'

const RetirementAccntOptions = (props: IFormProps) => {
  const [isLoading, setIsLoading] = useState(false)

  const { errorMessage, setErrorMessage } = useErrorMessage()
  const { updateOnboardProgress } = useRiseUpAPIV1()
  const gtmData = useGTMData(props.getValues)
  const sendDataToGTM = useGTMDispatch()
  const {
    getFormattedUTMParams, // Helper to generate a complete GTM event object
  } = useUTMTracking()
  const navigate = useNavigate()
  const location = useLocation()

  const handleRetiremenAccntType = (value: string) => {
    props.setRetirementAccntType(value)
    props.setValue('investingProfile.retirementAccountType', value)
  }

  const handleSubmit = async () => {
    setIsLoading(true)

    const data = {
      ...props.getValues(),
      lastCompletedStage: '3',
    }
    const formattedUTMParams = getFormattedUTMParams()
    const pathname = location.pathname
    const currentParams = queryString.parse(location.search)
    const updatedUrl = getModifiedUrlWithStep(pathname, currentParams, 'investor_personal_info')

    try {
      const updateOnboardProgressRes = await updateOnboardProgress(data)

      if (updateOnboardProgressRes.status === 201 || updateOnboardProgressRes.status === 200) {
        sendDataToGTM({
          event: 'funnel_step',
          step_title: 'RETIREMENT_ACCOUNT_TYPE',
          ...gtmData,
          ...formattedUTMParams,
        })
        navigate(updatedUrl)
        props.nextStep('3')
      }
    } catch (error: any) {
      setIsLoading(false)
      if (error.response.data === RiseUpErrors.DuplicatePhoneNumber) {
        setErrorMessage(RiseUpErrors.DuplicatePhoneNumber + ' Please update the phone number.')
        return
      }
      if (error.response.data === RiseUpErrors.DuplicateSSN) {
        setErrorMessage(RiseUpErrors.DuplicateSSN + ' Please update the ssn.')
        return
      }
      swal({
        title: 'Error!',
        text: 'Please check if your details are valid and correct. If error persists, contact us.',
        icon: 'error',
      })
    }
  }

  useEffect(() => {
    if (props.getValues('investingProfile.retirementAccountType')) {
      props.setRetirementAccntType(props.getValues('investingProfile.retirementAccountType'))
    }
  }, [props.getValues('investingProfile.retirementAccountType')]) // eslint-disable-line

  return (
    <div className="flex h-screen w-full flex-col lg:flex-row lg:justify-start">
      <div className="mt-10 flex flex-col sm:w-screen md:mt-0 md:min-h-screen md:w-[45%] lg:w-[40%] xl:w-[35%]">
        <div className="relative h-screen sm:h-auto sm:p-16 lg:hidden">
          <img className="w-screen" src={CompanyLogo} alt="CompanyLogo" />
        </div>
        <div className="relative hidden flex-grow lg:flex">
          <img className="flex h-screen w-full" src={Side2} alt="Side2" />
        </div>
      </div>

      <div className="flex flex-col p-10 sm:w-[100%] md:w-[55%] lg:h-screen lg:w-[60%] lg:overflow-y-scroll xl:w-[65%]">
        {/* <div className="justify-center mb-10 sm:hidden lg:flex">
          <div className="w-1/2">
            <img className="w-screen" src={CompanyLogo} alt="CompanyLogo" />
          </div>
        </div> */}

        <div className="md:my-3">
          <Stepper current={props.currentStage} />
        </div>

        <div className="pb-7 pt-10 text-center text-7xl font-semibold text-gray-900 sm:text-5xl lg:pb-7 lg:text-left lg:text-4xl">
          Account Type
        </div>

        <div className="gap-8 sm:grid lg:flex">
          <div
            style={{ border: '2px solid #E5E7EB' }}
            className={`flex min-h-[96px] flex-col items-center justify-center rounded-lg border-[#E5E7EB] p-7 text-center hover:cursor-pointer  sm:min-h-[252px] sm:border-solid sm:border-[#DDD] lg:w-1/4 lg:border-2 ${
              props.retirementAccntType === RetirementAccountEnum.TRUST_ACCOUNT
                ? 'border-[#1A56DB] bg-[#1A56DB] text-[#FFFFFF] shadow-xl'
                : ''
            }`}
            onClick={() => {
              handleRetiremenAccntType(RetirementAccountEnum.TRUST_ACCOUNT)
            }}
          >
            <img src={TrustIcon} alt={`${TrustIcon}`} className="xs:min-w-[142px] lg:min-w-[92px]" />

            <div
              className={`mt-4 max-h-[142px] text-5xl sm:text-3xl lg:text-base ${
                props.retirementAccntType === RetirementAccountEnum.TRUST_ACCOUNT ? 'font-bold' : 'font-normal'
              }`}
            >
              A Trust
            </div>
          </div>
          <div
            style={{ border: '2px solid #E5E7EB' }}
            className={`flex max-h-[142px] min-h-[96px] flex-col items-center justify-center rounded-lg border-[#E5E7EB] p-7 text-center hover:cursor-pointer  sm:min-h-[252px] sm:border-solid sm:border-[#DDD] lg:w-1/4 lg:border-2 ${
              props.retirementAccntType === RetirementAccountEnum.RETIREMENT_ACCOUNT
                ? 'border-[#1A56DB] bg-[#1A56DB] text-[#FFFFFF] shadow-xl'
                : ''
            }`}
            onClick={() => {
              handleRetiremenAccntType(RetirementAccountEnum.RETIREMENT_ACCOUNT)
            }}
          >
            <img
              src={RetirementIcon}
              alt={`${RetirementIcon}`}
              className="max-h-[142px] xs:min-w-[142px] lg:min-w-[92px]"
            />

            <div
              className={`mt-4 text-5xl sm:text-3xl lg:text-base ${
                props.retirementAccntType === RetirementAccountEnum.RETIREMENT_ACCOUNT ? 'font-bold' : 'font-normal'
              }`}
            >
              Retirement Account
            </div>
          </div>
        </div>

        <div className="w-full justify-center gap-3 py-10 sm:block lg:flex">
          {/* <div className="flex flex-col lg:w-[20%] sm:w-[100%]">
            <Button
              btnName={'Back'}
              onClickHandler={() => {
                props.previousStep('2')
              }}
            />
          </div> */}
          <div className="flex flex-col sm:w-[100%] lg:w-[80%]">
            <Button
              btnName={`Next: Account Info ${
                props.getValues('investingProfile.retirementAccountType') === 'TRUST_ACCOUNT'
                  ? '(Trust)'
                  : '(Retirement)'
              }
                `}
              btnType={'button'}
              onClickHandler={handleSubmit}
              disabled={props.getValues('investingProfile.retirementAccountType') === undefined}
            />
          </div>
        </div>
      </div>
      <LoaderModal isVisible={isLoading} />
      <MessageModal
        isVisible={errorMessage !== ''}
        onProceed={() => {
          // automatically set the step to appropriate form duplicate error
          if (errorMessage === RiseUpErrors.DuplicatePhoneNumber + ' Please update the phone number.') {
            setErrorMessage('')
            props.nextStep('3')
          }
          if (errorMessage === RiseUpErrors.DuplicateSSN + ' Please update the ssn.') {
            setErrorMessage('')
            props.nextStep('4')
          }
          setErrorMessage('')
        }}
        onCancel={() => {
          setErrorMessage('')
        }}
        title={'Error'}
        description={errorMessage}
        type={'error'}
        btn2={'Ok'}
      />
    </div>
  )
}

export default RetirementAccntOptions
